import React from "react";
import NotesCapture from "./NotesCapture";
import CameraSourceSwitch from "./CameraSourceSwitch";

import CameraAltIcon from "@mui/icons-material/CameraAlt";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

const checkSteps = [
    {
        label: "VIN number",
        component: (
            <CameraSourceSwitch step={0} imgIndex={0} assetMode="check" />
        ),
        icon: <CameraAltIcon />,
        isImage: true,
        isMandatory: true,
    },
    {
        label: "fullVehicle",
        component: (
            <CameraSourceSwitch step={1} imgIndex={1} assetMode="check" />
        ),
        icon: <CameraAltIcon />,
        isImage: true,
        isMandatory: false,
    },
    {
        label: "notes",
        component: <NotesCapture step={2} />,
        icon: <NoteAltIcon />,
        isImage: false,
        isMandatory: false,
    },
];

const excludeSteps = [
    {
        label: "notes",
        component: <NotesCapture step={0} />,
        icon: <NoteAltIcon />,
        isImage: false,
        isMandatory: true,
    },
    {
        label: "addPhoto",
        component: (
            <CameraSourceSwitch step={0} imgIndex={0} assetMode="exclude" />
        ),
        icon: <CameraAltIcon />,
        isImage: true,
        isMandatory: false,
    },
];
const createNewStep = (nextStep, imgIdx, mode) => ({
    label: "addPhoto",
    component: (
        <CameraSourceSwitch
            step={nextStep}
            imgIndex={imgIdx}
            assetMode={mode}
        />
    ),
    icon: <CameraAltIcon />,
    isImage: true,
    isMandatory: false,
});

const addNewSteps = [
    {
        label: "other",
        component: (
            <CameraSourceSwitch step={0} imgIndex={0} assetMode="check" />
        ),
        icon: <CameraAltIcon />,
        isImage: true,
        isMandatory: false,
    },
    {
        label: "notes",
        component: <NotesCapture step={0} />,
        icon: <NoteAltIcon />,
        isImage: false,
        isMandatory: false,
    },
];

export { checkSteps, excludeSteps, createNewStep, addNewSteps };
